import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M85.58 67C81.87 53.91 84.85 37.04 77.24 21.38C66.18 -1.40999 44.71 2.21997 44.71 2.21997C34.8 0.729972 19.94 4.03992 12.3 20.9199C6.80998 33.0499 7.29001 53.91 3.58001 67C-0.129987 80.09 0.399984 89.5799 3.79998 95.5699C6.11998 99.6599 9.86999 100.66 9.86999 100.66C9.86999 100.66 12.84 104.93 18.32 105.06C23 105.17 23.96 103.15 23.96 103.15C27.78 105.92 31.97 103.26 31.97 103.26C17.96 83.63 21.48 41.12 21.48 41.12C27.72 40.5 30.35 39.1899 30.35 39.1899C32.86 39.6899 34.68 38.71 34.68 38.71C37.42 38.85 44.17 39.54 52.41 38.71C52.41 38.71 56.3 39.6899 58.82 39.1899C58.82 39.1899 61.45 40.5 67.69 41.12C67.69 41.12 70.64 87.43 57.2 103.26C57.2 103.26 61.38 105.92 65.21 103.15C65.21 103.15 66.19 105.45 70.85 105.06C76.26 104.6 79.3 100.66 79.3 100.66C79.3 100.66 83.09 99.6899 85.37 95.5699C88.59 89.7499 89.29 80.09 85.58 67Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M71.96 13.62C71.96 13.62 78.7299 21.7099 79.5599 47.3099C80.1799 66.5999 87.1599 93.2199 77.4099 101.81"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M48.9299 5.72998C48.9299 5.72998 56.5499 20.0599 52.0399 38.5299"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M51.8301 6.68994C51.8301 6.68994 60.73 19.3199 54.48 38.6899"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.01 7.8999C55.01 7.8999 58.91 11.67 60.56 17.89C62.71 26 62.83 37.0599 58.81 39.1899"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M68.9401 31.2899C68.9401 31.2899 67.7101 39.9399 68.9401 53.9099C70.1701 67.8799 72.3701 79.24 68.8101 92.14C65.5901 103.8 60.1401 104.53 60.1401 104.53"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M14.48 17.71C14.48 17.71 9.13009 25.05 10.0301 44.33C10.9401 63.71 1.94003 88.92 11.35 102.13"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.3499 4.73999C45.3499 4.73999 43.49 5.35993 42.52 12.2999C41.36 20.5599 40.75 37.73 43.18 39.22"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.3399 6.68994C37.3399 6.68994 33.4499 10.06 32.7799 19.89C32.4699 24.51 32.8599 33.62 35.2599 38.22"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M34.16 7.8999C34.16 7.8999 29.7901 12.81 27.9301 20.2C26.5801 25.54 26.67 36.2299 30.36 39.1899"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
